import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Badge.module.scss';

export interface IBadge extends HTMLAttributes<HTMLDivElement> {
  text?: string;
  icon?: string;
  rootClassName?: string;
}

const Badge: FC<IBadge> = (props) => {
  const { text, className, rootClassName, icon } = props;
  const classes = classNames(styles.badge, styles[rootClassName ?? ''], className);

  return (
    <span className={classes}>
      {text?.toLowerCase()}
      {icon && <i className={icon} />}
    </span>
  );
};

export default Badge;
